import { Badge, Tooltip, Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { FaStar, FaStarHalf, FaRegStar, FaGraduationCap, FaBook, FaSeedling, FaBaby } from "react-icons/fa";
import { useTranslation } from "react-i18next";

interface MasteryBadgeProps {
  mastery: number;
}

const MasteryBadge: React.FC<MasteryBadgeProps> = ({ mastery = 0 }) => {
  const { t } = useTranslation();

  let colorScheme = "red";
  let labelKey = "masteryNotStarted";
  let icon = FaRegStar;

  if (mastery >= 0.9) {
    colorScheme = "green";
    labelKey = "masteryMastered";
    icon = FaGraduationCap;
  } else if (mastery >= 0.7) {
    colorScheme = "blue";
    labelKey = "masteryAdvanced";
    icon = FaStar;
  } else if (mastery >= 0.4) {
    colorScheme = "yellow";
    labelKey = "masteryLearning";
    icon = FaBook;
  } else if (mastery > 0) {
    colorScheme = "orange";
    labelKey = "masteryBeginning";
    icon = FaSeedling;
  } else {
    icon = FaBaby;
  }

  // Format the percentage
  const percentage = Math.round(mastery * 100);

  // Colors
  const bgColor = useColorModeValue(`${colorScheme}.50`, `${colorScheme}.900`);
  const textColor = useColorModeValue(`${colorScheme}.700`, `${colorScheme}.300`);
  const borderColor = useColorModeValue(`${colorScheme}.200`, `${colorScheme}.800`);

  return (
    <Tooltip
      label={t('common.masteryPercentage', { percentage })}
      hasArrow
      placement="top"
      bg={useColorModeValue(`${colorScheme}.100`, `${colorScheme}.800`)}
      color={useColorModeValue(`${colorScheme}.800`, `${colorScheme}.100`)}
    >
      <Flex
        as={Badge}
        colorScheme={colorScheme}
        borderRadius="full"
        px={3}
        py={1}
        alignItems="center"
        bg={bgColor}
        color={textColor}
        borderWidth="1px"
        borderColor={borderColor}
        boxShadow="sm"
        transition="all 0.2s"
        _hover={{
          transform: "translateY(-2px)",
          boxShadow: "md"
        }}
      >
        <Box as={icon} mr={1} fontSize="xs" />
        <Text fontWeight="semibold" fontSize="xs">
          {t(`common.${labelKey}`)}
        </Text>
      </Flex>
    </Tooltip>
  );
};

export default MasteryBadge;